import { render, staticRenderFns } from "./GreatEvent.vue?vue&type=template&id=05c086ac&scoped=true"
import script from "./GreatEvent.vue?vue&type=script&lang=js"
export * from "./GreatEvent.vue?vue&type=script&lang=js"
import style0 from "./GreatEvent.vue?vue&type=style&index=0&id=05c086ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c086ac",
  null
  
)

export default component.exports